import { render } from "./MilestoneDistributionPage.vue?vue&type=template&id=8edd5968"
import script from "./MilestoneDistributionPage.vue?vue&type=script&lang=js"
export * from "./MilestoneDistributionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__